"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentAuthorizationFactory = void 0;
const testing_1 = require("@engineering11/testing");
const candidate_user_model_1 = require("../models/candidate-user.model");
const mock_fixtures_1 = require("./mock.fixtures");
class EmploymentAuthorizationFactory extends testing_1.BaseMockFactory {
    defaultData() {
        const country = (0, testing_1.randomElement)(mock_fixtures_1.mockCountries);
        const legalWorkAuthorizationType = (0, testing_1.randomEnum)(candidate_user_model_1.EmploymentAuthorizationType);
        const visaSponsorshipRequired = (0, testing_1.randomBoolean)(0.1);
        const tempWorkAuthorizationExpiration = legalWorkAuthorizationType === candidate_user_model_1.EmploymentAuthorizationType.Temporary ? { month: (0, testing_1.randomNumber)(1, 12), year: (0, testing_1.randomNumber)(2020, 2060) } : undefined;
        const employmentAuthorization = {
            country,
            legalWorkAuthorizationType,
            visaSponsorshipRequired,
            tempWorkAuthorizationExpiration,
        };
        return employmentAuthorization;
    }
}
exports.EmploymentAuthorizationFactory = EmploymentAuthorizationFactory;
